import { ActivityMetadata, ActivityTag } from './types';
import { ClockIcon, PeopleIcon, ChecklistIcon } from './icons';
import MetadataBadge from './MetadataBadge';
import ActivityTags from './ActivityTags';
import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface ActivityHeaderProps {
  title: string;
  metadata: ActivityMetadata;
  tags: ActivityTag[];
}

/**
 * ActivityHeader Component
 * 
 * Activity title, metadata badges, and tags.
 * Responsive: Typography scales across breakpoints.
 */
export default function ActivityHeader({ title, metadata, tags }: ActivityHeaderProps) {
  return (
    <div
      className="flex flex-col gap-2 pt-6 px-6 sm:px-8 md:px-10 lg:px-12"
    >
      {/* Title - Scales 32px → 34px → 36px */}
      <h1
        className={`${ACTIVITY_DETAILS_TYPOGRAPHY.title.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.title.sizeClasses} ${ACTIVITY_DETAILS_TYPOGRAPHY.title.tracking} ${ACTIVITY_DETAILS_TYPOGRAPHY.title.leading}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: ACTIVITY_DETAILS_COLORS.textPrimary,
          margin: 0,
        }}
      >
        {title}
      </h1>

      {/* Metadata Row */}
      <div className="flex items-center gap-4">
        <MetadataBadge
          icon={<ClockIcon size={14} color={ACTIVITY_DETAILS_COLORS.textSecondary} />}
          text={metadata.duration}
        />
        <MetadataBadge
          icon={<PeopleIcon size={14} color={ACTIVITY_DETAILS_COLORS.textSecondary} />}
          text={metadata.playType}
        />
        <MetadataBadge
          icon={<ChecklistIcon size={14} color={ACTIVITY_DETAILS_COLORS.textSecondary} />}
          text={metadata.prepNeeded}
        />
      </div>

      {/* Tags */}
      <ActivityTags tags={tags} />
    </div>
  );
}
